import { NavLink, useLocation, useNavigate } from "react-router-dom";
import alreadyVerifiedImg from "../assets/alreadyVerified2.png";

const AlreadyVerified = () => {
   const { state } = useLocation();
    const navigate = useNavigate();
  const scratchNumber = state?.scratchNumber;
  return (
    <div style={styles.container}>
      
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
        Scratch Number : <span style={{ fontWeight: "bold" }}>{scratchNumber}</span>
      </h3>
       {/* <NavLink
        to="-1"
        style={{
          display: "inline-block",
          marginBottom: "30px",
          padding: "12px 24px",
          background: "#005487",
          color: "#fff",
          textDecoration: "none",
          alignSelf: "flex-start",
          borderRadius: "8px",
          fontWeight: "600",
          fontSize: "16px",
        }}
      >
        ← Back
      </NavLink> */}
      <img src={alreadyVerifiedImg} alt="Already Verified" style={styles.image} />
      <div style={{backgroundColor:'#03617e', color: '#fff', padding: '12px 24px', borderRadius: '8px', fontWeight: '600', fontSize: '16px',cursor: 'pointer', marginTop: '20px'}}
           onClick={() => navigate("/warranty")}>Verify Again</div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px 20px",
  },
  image: {
    maxWidth: "100%",
    height: "auto",
  },
};

export default AlreadyVerified;
